import { useMountEffect } from "@react-hookz/web";
import React from "react";

import { Container, StyledTickIcon } from "./styles";

type Props = {
  onImpression: () => void;
};
export const LoginReminderTooltip: React.FunctionComponent<Props> = ({ onImpression }) => {
  useMountEffect(() => {
    onImpression();
  });

  return (
    <Container>
      <StyledTickIcon />
      Log in again for better content recommendations.
    </Container>
  );
};

LoginReminderTooltip.displayName = "LoginReminderTooltip";
